export default __webpack_public_path__ + "static/media/pwc.b978fed6.png";